import { useRef } from "react";

/**
 * Latches a boolean on: once `value` is true the hook keeps returning true for
 * the lifetime of the component, regardless of later values.
 *
 * Used to hold the discretionary service charge selector open. Once the guest
 * has been offered the choice it must not be taken away mid-session by a
 * recalculation that transiently withdraws the permission — picking "None"
 * zeroes the charge, and refreshing the pre-order can momentarily drop the
 * required payment. Without the latch the guest would be left looking at a 0%
 * charge they can no longer change.
 *
 * @param value - The current permission
 * @returns true once `value` has been true at least once
 */
export function useLatchedTrue(value: boolean): boolean {
  const latched = useRef(false);
  latched.current = latched.current || value;
  return latched.current;
}
